import { Box, Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Add from "@material-ui/icons/Add";
import Remove from "@material-ui/icons/Remove";
import Drawer from "@mui/material/Drawer";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { fetchBasket, updateBasket } from "../../services/basket/actions";
import { getPublicPrice } from "../../utils/weightUtils";
import "./Product.scss";

const getBasketAmount = (productId, basketProducts) => {
  if (basketProducts.length > 0) {
    for (let i in basketProducts) {
      // dit heeft mogelijk een andere manier nodig om de store te benaderen
      if (parseInt(basketProducts[i].product_id) === parseInt(productId)) {
        return basketProducts[i].number;
      }
    }
  }
  return 0;
};

function ProductAddToBasket(props) {
  const [submitted, setSubmitted] = useState(false);
  const [count, setCount] = useState(
    getBasketAmount(props.productId, props.basketProducts)
  );
  const [inputOpen, closeInput] = useState(false);
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(false);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    let count = getBasketAmount(props.productId, props.basketProducts);
    setCount(count);
    setValue(count);
    // eslint-disable-next-line
  }, [props.productId]);

  const addToBasket = () => {
    props.updateBasket(props.currentLocation.id, props.productId, count);
    setTimeout(() => {
      props.fetchBasket(props.currentLocation.id, props.userId);
      setOpen(false);
    }, 500);
  };

  const handleChange = (event) => {
    setSubmitted(false);
    if (event.target.value == "") {
      //do this to avoid item being instantly deleted when backspaced in basket
      var location = window.location.href.substring(
        window.location.href.lastIndexOf("/") + 1
      );
      if (location == "basket") {
        setValue(null);
        return;
      }
      props.updateBasket(props.currentLocation.id, props.productId, 0);
      props.fetchBasket(props.currentLocation.id, props.userId);
      setCount(0);
      setValue(null);
      return;
    }
    setCount(parseInt(event.target.value));
    setValue(parseInt(event.target.value));
    if (event.target.value > 0) {
      setSubmitted(true);
    }
    setTimeout(() => {
      setSubmitted(false);
      closeInput(!inputOpen);
    }, 2000);
  };

  const handleClickAdd = () => {
    setSubmitted(false);
    setCount(count + 1);
    setValue(count + 1);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      closeInput(!inputOpen);
    }, 2000);
  };

  const handleClickMinus = () => {
    if (count - 1 < 0) {
      return;
    }
    setSubmitted(false);
    setCount(count - 1);
    setValue(count - 1);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      closeInput(!inputOpen);
    }, 2000);
  };

  let input_class = submitted ? "submitted" : "notSubmitted";
  if (props.productId) {
    return (
      <React.Fragment>
        <Box>
          <Button
            variant="contained"
            color="primary"
            aria-label="add"
            onClick={handleOpen}
            size="small"
          >
            <Add />
          </Button>
        </Box>

        <Drawer
          anchor={"bottom"}
          open={open}
          onClose={toggleDrawer("bottom", false)}
        >
          <Box sx={{ width: "auto", padding: 2 }} role="presentation">
            <div className="photoDivProd">
              <Link
                style={{ textDecoration: "none" }}
                to={{
                  pathname: "/productinfo",
                  state: { from: props.rowData },
                }}
              >
                {props.rowData.image ? (
                  <img className="photoProd" src={props.rowData.image}></img>
                ) : null}
                {props.rowData.bio ? (
                  <div>
                    <p className="productNameProd">{props.rowData.name}</p>{" "}
                    <img
                      className="bio"
                      src={
                        "https://www.goeieete.nl/wp-content/themes/goeieete/assets/logo-bio.svg"
                      }
                    />
                  </div>
                ) : (
                  <p className="productNameProd">{props.rowData.name}</p>
                )}
              </Link>
              <Link
                style={{ textDecoration: "none", color: "black" }}
                to={{
                  pathname: "/supplierinfo",
                  state: { from: props.rowData },
                }}
              >
                <p1 className="supplierNameProd">
                  {props.rowData.supplier_name}
                </p1>
                <br />
              </Link>
              <Typography
                component="span"
                variant="body2"
                className="inline"
                color="textPrimary"
              >
                {getPublicPrice(props.rowData)}
              </Typography>
              <br />

              <div className="counterDiv">
                <button onClick={handleClickMinus} className="buttonRemove">
                  <Remove />
                </button>
                <Box textAlign="center">
                  <input
                    className={input_class}
                    placeholder={count}
                    value={value}
                    onChange={handleChange}
                    type="number"
                    min="0"
                    max="10000"
                  />
                </Box>
                <button onClick={handleClickAdd} className="buttonAdd">
                  <Add />
                </button>
              </div>
              <br />
              <br />
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  aria-label="add"
                  onClick={addToBasket}
                  size="medium"
                >
                  <Typography
                    component="span"
                    variant="body2"
                    className="inline"
                    color="white"
                    style={{ fontWeight: 600 }}
                  >
                    Update winkelmandje
                  </Typography>
                  <br />
                </Button>
              </Box>
            </div>
            <br />
          </Box>
        </Drawer>
      </React.Fragment>
    );
  } else {
    return (
      <Box p={1}>
        <p>Niks</p>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  return {
    basketProducts: state.basket.products,
    currentLocation: state.currentInformation.current_location,
    userId: state.login.data.user_id,
  };
}

export default connect(mapStateToProps, {
  updateBasket,
  fetchBasket,
})(ProductAddToBasket);
